module.exports = __webpack_public_path__ + "img/PXL_20230523_205830918.81181809.jpg";